<template>
  <div class="platform-info-edit-wrp ft-12">
    <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-custom-class="prod-custom-loading" class="tm-form">
      <slot name="errMsg"></slot>
      <div v-if="!shopList.length" style="margin: 100px 45%">
        <el-link
          href="https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/bindshop.do?staffId=gyl_398487408833024_1_scm3"
          target="_blank"
          >绑定天猫店铺</el-link
        >
      </div>
      <template v-else>
        <!-- <h3 style="margin-block-start: 0px; margin-block-end: 0px">天猫产品信息</h3> -->
        <span class="tips"
          >注：因天猫产品平台发布商品流程较为特殊，商品必须挂靠在一个产品上，其产品属性会和商品属性一同显示在手淘app商品详情页的【产品参数】模块</span
        >
        <el-tabs class="tm-form-shop-tabs" v-model="activeShop" @tab-click="switchShop">
          <el-tab-pane v-for="shop in shopList" :key="shop.id" :name="shop.id + ''">
            <span slot="label">
              <el-image style="width: 16px; height: 16px; margin-right: 5px; top: 4px" :src="shop.icon"></el-image>{{ shop.shortTitle || shop.title }}
              <i v-if="shop.itemComplete" class="el-icon-success" style="color: rgb(17, 231, 35)"></i>
              <i v-else style="color: rgb(237, 13, 13)" class="el-icon-warning"></i>
            </span>
          </el-tab-pane>
        </el-tabs>
        <template v-if="!self_form.categoryId && this.openSource !== 'shopGoods'">
          <el-alert type="warning" style="margin-bottom: 10px;"> 
            <div slot="title">
              <i class="el-icon-warning-outline" style="font-size: 24px;color: #faad14;margin-right:10px;"></i>
              <span style="color:#070707;">是否自动生成天猫资料？</span>
              <el-button type="text" @click="toCreateForm">立即生成</el-button></div>
            <div style="color: #F56C6C;">天猫资料将由系统自动生成，以提高铺货资料完善效率，生成资料如需调整，可自行编辑资料后保存 </div>
          </el-alert>
        </template>
        <template v-if="shopEmpower">
          <h3>天猫产品信息 <el-button v-if="!noNeedProductInfo" style="margin-left: 10px; font-size: 12px;" type="link" @click="switchExpand">{{ isExpand ? '折叠' : '展开' }}</el-button></h3>
          <el-form
            ref="self_form"
            class="product-form"
            :model="self_form"
            label-width="100px"
          >
            <el-form-item label="商品分类：" prop="categoryIds">
              <div class="category ft-12" v-if="activeShop && self_form.detailLoaded">
                <category-input
                  ref="cinput"
                  :shopId.sync="activeShop"
                  :baseItemId="baseItemId"
                  v-model="self_form.categoryIds"
                  :isSupportAi="true"
                  @change="catagoryChange"
                  platform="tm"
                />
                <p v-if="noNeedProductInfo" class="tips">该类目无需发布产品，维护商品资料后发布商品</p>
              </div>
            </el-form-item>
            <span v-show="isExpand && !noNeedProductInfo">
              <template v-for="(shop, shopIndex) in self_form.productValues">
                <template v-for="(ui, uiIndex) in uiMaps[shops[shopIndex].shopId]">
                  <el-form-item
                    v-if="ui.isShowFn ? ui.isShowFn(shop) : true"
                    :key="`${shopIndex}-${uiIndex}`"
                    :label="ui.label"
                    :prop="`productValues.${shopIndex}.${ui.name}`"
                    :rules="ui.rules"
                  >
                    <component
                      :ref="ui.name"
                      :ui="ui"
                      :is="ui.component.component"
                      :props="ui.component.props"
                      :value="shop[ui.name]"
                      :shopId="shops[shopIndex].shopId"
                      @change="v => changeProductValues(ui, v)"
                      @blur="v => onProductValueBlur(ui, v)"
                    ></component>
                  </el-form-item>
                </template>
              </template>
            </span>
          </el-form>
          <span v-show="isExpand">
            <ProductForm v-if="showProductForm" ref="ProductFormRef" :schema="step2schema" :oriDatas="oriDatas"></ProductForm>
            <div style="padding-left: 30px" v-if="showProductForm && !isCanRenderForm">
              <el-button type="primary" @click="publish"> 发布 </el-button>
              <p v-if="!showSchemaFrom" class="tips">天猫商品需发布产品资料后，获取商品资料信息</p>
            </div>
          </span>
          <el-divider></el-divider>
          <div v-if="showSchemaFrom">
            <h3>天猫商品信息</h3>
            <Step3 ref="step3" :oriDatas="oriDatas" :schema="schema" :changeToBase="changeToBase" :baseItemId="baseItemId" :shopId="activeShop" :shops="shops" :detailHasCategory="detailHasCategory" />
          </div>
        </template>
        <div v-else>
          <span class="tips-danger"
            >提示：店铺授权已失效，请点击
            <el-link
              href="https://oauth.taobao.com/authorize?response_type=code&client_id=23204092&state=1000&view=web&redirect_uri=https://erp.superboss.cc/refresh.do?staffId=gyl_398487408833024_1_scm3"
              target="_blank"
              >重新授权</el-link
            ></span
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { merge_fieldDescriptorList, step1Form2Data, reversValue,getWirelessDescWidthAndHeight } from './components/ShelvesFlow/utils/data';
import {
  queryTmShopList,
  getTmDetail,
  getTmDetailByOtherShop,
  getTmFastDetail,
  matchHasProductId,
  getProductInfo,
  step2Fetch,
  getProductSchema,
  getStep3Schema,
  getTmBrandList,
  getProductForm,
  _formatGoodsItem,
  getProductConversionData,
  getDetailConversionData,
} from '@/servers/prod/center/tm.js';
import { getShopGoodsItemDetail } from '@/api/prod/center/shopGoods'
import { step1FormUI, step2FormUI, step3FormUI } from './components/ShelvesFlow/utils/ui';
import CategoryInput from '../PlatformCategoryInput/index.vue';
import ProductForm from './components/ProductForm.vue';
import Step3 from './components/ShelvesFlow/components/Step3.vue';

import _ from 'lodash';
import { getDistributionConfig } from '@servers/prod/conf/index.js'
import { queryCategoryConfigInfo } from '@/api/prod/conf/index.js'

export default {
  provide(){
    return {
      isShelves: false,
      openSource:this.openSource
    }
  },
  components: {
    CategoryInput,
    ProductForm,
    Step3,
  },
  props: {
    rowData: {
      type: Object,
      default() {
        return {};
      },
    },
    canPublishPlatform: {
      type: Array,
      default() {
        return [];
      },
    },
    baseItemId: [Number, String],
    changeToBase: {
      type: Function,
      default() {
        return () => {}
      }
    },
    openSource:{
      type:String,
      default:''
    },
  },
  data() {
    return {
      loading: false,
      shopEmpower: false,
      oriDatas: [],
      self_form: {},
      schema: {}, // 商品信息 schema
      step2schema: {}, // 产品信息 schema
      shops: [],
      activeShop: '',
      shopList: [],
      brandList: [],
      showProductForm: false,
      showSchemaFrom: false,
      isCanRenderForm: this.canPublishPlatform && this.canPublishPlatform.includes('tm'),
      noNeedProductInfo: false,
      uiMaps: {}, // 以店铺id作为key的表单ui
      isExpand: true,
      needCheckProSchema: true,
      detailHasCategory: [],
      autoCropImageConfigList: [],
    };
  },
  computed: {
      ...mapGetters(['tmIsNewWirelessDesc']),
  },
  watch: {
    'self_form.categoryIds': {
      handler(v) {
        if (!v || !v.length) return;
        this.self_form.categoryId = v[v.length - 1];
      },
      immediate: true,
    },
    'self_form.categoryId': {
      async handler(v) {
        if (!v) return;
        await this.fetchProductSchema();
        this.$nextTick(() => {
          this.renderUI();
        });
      },
      immediate: true,
    },
    rowData: {
      handler(v) {
        this.init();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['updateTMIsNewWirelessDesc']),
    // 切换店铺
    switchShop() {
      this.self_form.categoryId = '';
      this.self_form.categoryIds = [];
      this.showSchemaFrom = false;
      this.showProductForm = false;
      this.updateShopHandle();
      this.getTmDetail();
    },
    catagoryChange(categoryIds, categoryNames) {
      this.self_form.categoryNames = categoryNames ? categoryNames.join(',') : '';
      // 类目变化时，获取产品参数图片（categoryIds 已更新，从最后一项取 leafCategoryId）
      if (categoryIds && categoryIds.length) {
        this.fetchProductParamImage(categoryIds[categoryIds.length - 1]);
      }
    },
    // 清空数据
    // 由于dialog关闭未销毁实例，会有数据缓存问题，需要在弹窗关闭时调用一下
    clear_specification() {
      const $skuRef = this.$refs?.step3?.$refs?.sku
      if($skuRef) {
        $skuRef[0].specifications = []
      }
    },
    switchExpand() {
      this.isExpand = !this.isExpand;
    },
    async changeProductValues(ui, v) {
      const values = this.self_form.productValues[0];
      this.$set(this.self_form.productValues[0], ui.name, v)
      if (ui.name == 'prop_20000') {
        this.self_form.brandId = values['prop_20000'];
      }
      if (ui.type !== 'INPUT') {
        this.renderUI();
      }
    },
    async onProductValueBlur(ui, v) {
      this.$set(this.self_form.productValues[0], ui.name, v)
      if (ui.type === 'INPUT') {
        this.renderUI();
      }
    },
    async renderUI() {
      this.showSchemaFrom = false;
      if (this.noNeedProductInfo) {
        this.isCanRenderForm = true;
        this.getSchema();
      } else {
        const step1Data = await this.method_getStep1Data();
        if (step1Data) {
          this.saveStep1Data(step1Data);
          await this.step2init();
          await this.checkProSchema(step1Data);
          if (this.isCanRenderForm) {
            this.getSchema();
          } else {
            this.$nextTick(async () => {
              // 如果产品信息都没值，调取接口自动填充（从其他平台抓取）
              if(!this.$refs.ProductFormRef) return
              let step2Data = await this.$refs.ProductFormRef.method_getData(true);
              if(!step2Data.some(item => item.defaultValue)) {
                const res = await getProductConversionData({
                  shopId: step1Data[0].shopId,
                  baseItemId: step1Data[0].baseItemId,
                  categoryId: step1Data[0].categoryId,
                  brandId: this.self_form.brandId,
                });
                if(res?.length) {
                  const [ui, form] = step2FormUI(this.step2schema, res[0]);
                  this.$refs.ProductFormRef.setForm(form)
                }
              }
            })
          }
        }
      }
    },

    saveStep1Data(step1Data) {
      this.self_form.categoryId = step1Data[0].categoryId;
      this.self_form.categoryNames = step1Data[0].categoryNames;
      // 第一步成功后，需要将类目的一些信息替换
      this.oriDatas[0].categoryIds = step1Data[0].categoryIds.split(',');
      this.oriDatas[0].categoryNames = step1Data[0].categoryNames;
      this.oriDatas[0].categoryId = step1Data[0].categoryId;
    },
    // 检测是否可以拉取商品信息schame
    async checkProSchema(step1Data) {
      this.isCanRenderForm = false;
      if(this.needCheckProSchema) {
        const step1Res = await matchHasProductId(step1Data);
        const productId = step1Res[0]?.productId;
        this.isCanRenderForm = !!productId;
        if(productId) {
          this.getProductList(productId);
        }
      } else {
        this.isCanRenderForm = true;
        this.needCheckProSchema = true
      }
    },
    // 根据productId获取产品信息
    async getProductList(productId) {  
      if(!productId || !this.$refs.ProductFormRef) return;
      const productInfo = await getProductInfo({
        shopId: this.activeShop,
        categoryId: this.self_form.categoryId,
        productId
      })
      this.$nextTick(() => {
        const [ui, form] = step2FormUI(this.step2schema, {fieldDescriptorList: productInfo});
        this.$refs.ProductFormRef.setForm(form)
      })
    },

    async getSchema() {
      const categoryId = this.self_form.categoryId;
      const baseItemId = this.self_form.baseItemId || this.rowData.baseItemId;
      const shopId = this.activeShop;
      if (!categoryId || !baseItemId || !shopId || !this.isCanRenderForm) return;
      this.showSchemaFrom = true;
      this.loading = true;
      const schema = await getStep3Schema({
        shopId,
        categoryId,
        baseItemId,
      }, null, { isNeedLoading: false });
      // PC详情描述需要展示，如果没有就写死一条发布规则
      if(schema && !schema.description){
        let description = this.self_form.fieldDescriptorList.find(item => item.name === 'description') || {}
        let children = null
        const getChildren = (arr) => {
          let result = arr.map(item => {
            if(item.children){
              // item.type = 'INPUT'
              item.type = item.type || 'COMPLEX'
              getChildren(item.children) // 递归处理子节点
            }else{
              // item.type = 'COMPLEX'
              item.type = item.type || 'INPUT' // 设置默认类型为INPUT
            }
            return item
          });
          return result
        }
        if(description.children){
          children = getChildren(description.children)
        }
        schema.description = {
          children:children || null,
          dataId:null,
          defaultValue:null,
          extendValue:null,
          id:null,
          label: "PC端详情描述",
          name: "description",
          options:null,
          propType:null,
          properties:[],
          rules:{valueTypeRule:'html;html'},
          type:description?.children?.length ? 'COMPLEX' : 'INPUT',
          valueDisplayName:null,
          valueType:null,
        }
        if(schema.wireless_desc){ // 平台没有返回pc详情标识
          schema.wireless_desc._noDescription = true
        }
      }
      // 新版手机端描述发布规则平台没有返回必填属性，不填铺不了货，所以写死必填属性
      if(schema && schema.wireless_desc){
        let version = schema.wireless_desc?.children?.find(item => item.name === 'version')
        if(version){
          let rules = schema.wireless_desc?.rules
          if(rules && !rules.requiredRule){
            schema.wireless_desc.rules.requiredRule = 'true'
          }
        }
      }
      const desc = schema && schema.description
      if (desc?.type === 'COMPLEX' && Array.isArray(desc.children)) {
        const mod = desc.children.find(child => child?.name === 'desc_module_user_mods')
        if (mod) {
          mod.type = 'COMPLEX'
        }
      }
      // 检查是否有产品参数图片数据（diaopai_pic），如果有就添加到 schema 中
      const hasProductParamImage = this.oriDatas.some(item =>
        item.fieldDescriptorList && item.fieldDescriptorList.some(f => f.name === 'diaopai_pic' && f.defaultValue)
      );
      if (hasProductParamImage && schema && !schema.diaopai_pic) {
        schema.diaopai_pic = {
          name: 'diaopai_pic',
          label: '产品参数图片',
          type: 'INPUT',
          rules: { requiredRule: 'true' },
          properties: [],
          valueTypeRule: 'url'
        };
      }
      this.schema = schema
      this.$nextTick(async () => {
        // let propData = await this.$refs.step3.method_getPropData(true);
        // const matchPropsValue = propData.some(item => item.defaultValue)
        // const matchItem_imagesValue = this.$refs.step3.form?.item_images?.length
        // if(!matchPropsValue || !matchItem_imagesValue) {
        //   const step1Data = await this.method_getStep1Data();
        //   const res = await getDetailConversionData({
        //     shopId: step1Data[0].shopId,
        //     baseItemId: step1Data[0].baseItemId,
        //     categoryId: step1Data[0].categoryId,
        //   });
        //   if(res?.length) {
        //     const [ui, form] = step3FormUI.call(this, this.schema, res)
        //     if(!matchPropsValue) {
        //       this.$refs.step3.setForm(ui, form, 'props')
        //     }
        //     if(!matchItem_imagesValue) {
        //       this.$refs.step3.setForm(ui, form, 'item_images')
        //     }
        //   }
        // }
        if(this.$refs.ProductFormRef) {
          let step2Data = await this.$refs.ProductFormRef?.method_getData();
          if(!step2Data) {
            this.getProductList(this.self_form.productId)
          }
        }
        this.loading = false;
      })
    },

    // 产品信息schema
    async step2init() {
      const categoryId = this.self_form.categoryId;
      const brandId = this.self_form.brandId;
      const shopId = this.activeShop;
      if (!categoryId || !shopId) return;
      const fieldDescriptorList = step1Form2Data(this.self_form.productValues[0]);
      const _step1fields = fieldDescriptorList.map(item => item.name); // 步骤1已填的字段
      let ori_step2schema = await getProductSchema({
        // 获取产品信息原始表单schema
        shopId,
        brandId,
        categoryId,
      });
      let step2schema = {}; // 产品信息的最终表单规则
      for (const key in ori_step2schema) {
        // 对原始表单schema做一些过滤
        if (_step1fields.includes(key) || ori_step2schema[key]?.rules?.disableRule === 'true') {
          // 过滤掉步骤1的字段 或者 有disableRule为true这个规则的字段
          continue;
        }
        step2schema[key] = ori_step2schema[key];
      }
      this.$set(this, 'step2schema', step2schema);
      this.showProductForm = true;
    },
    // 发布产品信息
    async publish() {
      const step1Data = await this.method_getStep1Data();
      let step2Data = await this.$refs.ProductFormRef?.method_getData();
      if (!step1Data || !step2Data) {
        this.$message.error('请完善产品信息表单');
        return;
      }
      const params = [
        {
          ...step1Data[0],
          brandId: this.self_form.brandId,
          fieldDescriptorList: merge_fieldDescriptorList([...step1Data[0].fieldDescriptorList], [...step2Data]),
        },
      ];
      const res = await step2Fetch(params);
      if(!res) return;
      this.isCanRenderForm = true;
      this.getSchema();
    },
    method_getStep1Data() {
      return new Promise((resolve, reject) => {
        this.$refs.self_form.validate(async pass => {
          if (pass) {
            const data = [
              {
                shopId: this.activeShop,
                baseItemId: this.rowData.baseItemId,
                categoryId: this.self_form.categoryId,
                categoryIds: this.self_form.categoryIds.join(','),
                categoryNames: this.self_form.categoryNames,
                fieldDescriptorList: step1Form2Data(this.self_form.productValues[0]),
              },
            ];
            resolve(data);
          } else {
            resolve(false);
          }
        });
      });
    },
    method_saveSuccess() {
      this.getShopList();
    },
    async method_getFormData() {
      if (!this.$refs.step3) {
        this.$message.error('请先进行发布产品信息！');
        return false;
      }
      return new Promise(async resolve => {
        let step3Data = await this.$refs.step3.method_getData();
        if (!step3Data) return resolve(false);
        const { fieldDescriptorList, specifications, skuList, postage_id_map, pureType } = step3Data;
        let spParmas = {}; // 规格参数
        if (specifications) {
          spParmas.specifications = specifications;
          // const itemSkuList = skuList.map(item => {
          //   Object.keys(item).filter(key => /^sku_/.test(key)).forEach(key => {
          //     const matchField = (item.skuFieldDescriptorList || []).find(attr => attr.name === key);
          //     if (matchField) {
          //       matchField.defaultValue = item[key]
          //     } else {
          //       item.skuFieldDescriptorList.push({
          //         id: null,
          //         name: key,
          //         label: null,
          //         dataId: null,
          //         defaultValue: item[key],
          //         type: null,
          //         rules: null,
          //         options: null,
          //         children: null
          //       })
          //     }
          //     delete item[key];
          //   })
          //   item.skuSpecifications = JSON.stringify(item.skuSpecifications);
          //   return item;
          // });
          spParmas.itemSkuList = skuList;
          spParmas.skuList = [];
        }
        const step1Data = this.$refs.self_form ? await this.method_getStep1Data() : true;
        const step2Data = this.$refs.ProductFormRef ? await this.$refs.ProductFormRef?.method_getData() : [];
        if (!this.schema.darwin_sku && (!step1Data || !step2Data)) { // 非达尔文sku，需要校验步骤1和步骤2
          this.$message.error('请完善产品信息表单');
          resolve(false);
          return;
        }
        let formData = [];
        for(const shopData of this.oriDatas){
          const { categoryId, categoryIds, categoryNames } = this.self_form;
          let _fieldDescriptorList = merge_fieldDescriptorList(
            [...shopData.fieldDescriptorList],
            [...(step1Data?.length ? step1Data[0].fieldDescriptorList : []), ...(step2Data || []), ...fieldDescriptorList,  postage_id_map[shopData.shopId]]
          );
          
          // 新版手机端详情图片需要传图片宽高信息
          let newFieldDescriptorList = await getWirelessDescWidthAndHeight(_fieldDescriptorList,shopData.fieldDescriptorList)
          formData.push({
            ...shopData,
            categoryId,
            categoryIds: categoryIds.join(','),
            categoryNames,
            fieldDescriptorList: newFieldDescriptorList,
            ...spParmas,
            productId: null,
            pureType,
          })
        }
        localStorage.setItem('tmLastSwatchShopId', this.activeShop);
        resolve(formData);
      });
    },
    // 获取每个店铺的品牌列表
    async fetchBrandList() {
      const shopId = this.activeShop;
      const res = await getTmBrandList({
        shopId,
      });
      this.brandList = res;
    },
    // 获取第一步的匹配的产品规则
    async fetchProductSchema() {
      this.noNeedProductInfo = false;
      const categoryId = this.self_form.categoryId;
      const shopId = this.activeShop;
      let uiMaps = {};
      let _form = {};

      const res = await getProductForm({
        shopId,
        categoryId,
      });
      // 返回结果为null时，不需要产品信息，直接省去中间过程，加载商品信息
      if (!res) {
        this.noNeedProductInfo = true;
        return;
      }
      const ui = step1FormUI(res);
      // 生成表单ui
      uiMaps[shopId] = this.genUIBy(ui);

      let fieldDescriptorList = step1Form2Data(this.self_form.productValues[0]);
      fieldDescriptorList =
        fieldDescriptorList && fieldDescriptorList.length ? fieldDescriptorList : this.self_form.fieldDescriptorList || [];
      ui.forEach(item => {
        if (!this.brandList.length && item.name === 'prop_20000') return; // 若店铺没品牌就不给品牌赋初始值
        // 如果是name没有匹配上，再走一遍label（型号）的匹配
        const curField = fieldDescriptorList.find(field => field.name == item.name) || fieldDescriptorList.find(field => field.label == item.label) || {};
        _form[item.name] = reversValue(curField);
      })

      this.self_form.productValues = [_form];
      this.self_form.brandId = _form['prop_20000'];

      this.uiMaps = uiMaps;
    },
    genUIBy(ui) {
      let _ui = _.cloneDeep(ui); // 每家店铺一份ui

      _ui.forEach(item => {
        if (!this.brandList.length && item.name === 'prop_20000') {
          // 该店铺没有品牌
          item._options = item.options; // 备份原始的，用于之后刷新品牌重新比较用
          item.options = [];
          return false;
        }

        let _brandList = this.brandList.find(brand => `prop_${brand.pid}` === item.name);
        if (_brandList) {
          // 品牌列表的pid与当前ui的name匹配上认为当前ui是品牌
          // 将当前ui的options与店铺的品牌进行一个筛选，只保留两边vid都相等的品牌选项
          item._options = item.options; // 备份原始的，用于之后刷新品牌重新比较用
          item.options = this.brandList.filter(brand => item.options.find(op => op.value === `${brand.vid}`));
          return true;
        }
      });
      return _ui;
    },
    // 初始店铺
    updateShopHandle() {
      const shop = this.shopList.find(item => item.id == this.activeShop) || this.shopList[0];
      this.shops = [
        {
          shopId: shop.id,
          shopName: shop.shortTitle || shop.title,
        },
      ];
      this.shopEmpower = (shop.state == 2 || shop.state == 3) && shop.active != 0; // 店铺状态（正常且已授权才能使用）
      if (!this.shopEmpower) return;
      this.fetchBrandList();
    },
    async getShopList() {
      const res = await queryTmShopList({
        pageNo: 1,
        pageSize: 300,
        source: 'tm',
        baseItemId: this.rowData.baseItemId,
      });
      if(this.openSource === 'shopGoods'){ // 来自店铺商品页面
          let {shopId} = this.rowData;
          this.shopList = (res.list || []).filter(item => item.id === shopId);
      }else{
          this.shopList = res.list || [];
      }
    },
    async toCreateForm() {
      const platformType = 'tm'
      const form = await getTmFastDetail({baseItemId: this.baseItemId, platformType, shopId: this.activeShop })
      this.handleFormData(form)
      setTimeout(async () => {
        // AI自动生成的资料，后端没有存储productId, 需要这里调一下接口/tm/matchProductSchema
        const step1Data = await this.method_getStep1Data();
        matchHasProductId(step1Data)
      }, 2000);
    },
    async getTmDetail() {
      if (!this.shopEmpower || !this.activeShop) return;
      this.loading = true;
      let form;
      if(this.openSource === 'shopGoods'){ // 来自店铺商品页面
          let {source,shopId,numIid} = this.rowData;
          let obj = await getShopGoodsItemDetail({
            platformItemId:numIid,
            shopId:shopId,
            platform:source
          }, {isNeedLoading: false});
          form = [obj]
      }else if(this.openSource === 'taskCenter') { // 任务中心
        form = [this.rowData]
      } else {
        form = await getTmDetail({
          baseItemId: this.rowData.baseItemId,
          shopIds: this.activeShop,
        }, {isNeedLoading: false});
      }
      this.isExpand = true;
      let { needOtherDetail = false, fieldDescriptorList = [] } = form.length > 0 ? form[0] : {};
      if(this.openSource === 'shopGoods' || this.openSource === 'taskCenter'){ // 来自店铺商品页面
        needOtherDetail = false;
      }
      if (!form.length || needOtherDetail) {
        form = await getTmDetailByOtherShop({
          baseItemId: this.rowData.baseItemId,
          shopId: this.activeShop,
        }, {isNeedLoading: false});
        if (needOtherDetail && form.length > 0) {
          // 需要保留原detail接口中的属性值
          const { fieldDescriptorList: newFieldDescriptorList = [] } = form[0];
          const list = (newFieldDescriptorList || []).map(item => {
            const matchItem = (fieldDescriptorList || []).find(desc => {
              return desc.name === item.name;
            })
            if (matchItem) {
              return matchItem;
            }
            return item;
          });
          form[0].fieldDescriptorList = list;
        }
      }
      this.loading = false;
      this.handleFormData(form);
      this.detailHasCategory = form[0].categoryIds || [];
    },
    // 处理表单数据
    handleFormData(form) {
      form = form && form.length ? form : [_formatGoodsItem({})];
      this.oriDatas = _.cloneDeep(form);
      const _form = { productValues: [], ...form[0] };
      this.isExpand = !_form.productId;
      this.needCheckProSchema = !_form.productId;
      this.updateTMIsNewWirelessDesc(!!_form.newWirelessDesc);
      this.$set(this, 'self_form', {
        ..._form,
        detailLoaded: true,
      });
    },
    async init() {
      await this.getShopList();
      if (!this.shopList.length) return;
      const shop = this.shopList[0] || {};
      const selectShops = this.rowData.selectShops || [];
      const lastShopId = localStorage.getItem('tmLastSwatchShopId');
      let actShop = ''
      if(this.openSource === 'taskCenter'){
        actShop = this.rowData?.shopId
      }
      this.activeShop = (lastShopId || actShop || selectShops[0] || shop.id) + '';
      localStorage.removeItem('tmLastSwatchShopId')
      this.updateShopHandle();
      this.getTmDetail();
      this.getConf()
    },
      // 获取配置
    async getConf() {
        const res = await getDistributionConfig({shopType: 'tm'});
        this.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
        localStorage.setItem('autoCropImageConfigList',this.autoCropImageConfigList)
    },
    // 获取产品参数图片（按类目优先，然后通用配置）
    async fetchProductParamImage(leafCategoryId) {
      // 优先使用传入的参数，否则用 self_form.categoryId
      const categoryId = leafCategoryId || this.self_form.categoryId;
      if (!categoryId || !this.activeShop) return;
      try {
        const res = await queryCategoryConfigInfo({
          shopType: 'tm',
          leafCategoryId: categoryId
        });
        if (res.result === 1 && res.data?.productParamImageUrl) {
          // 更新 oriDatas 中的 diaopai_pic 字段（产品参数图片）
          this.oriDatas.forEach((item, index) => {
            if (item.fieldDescriptorList) {
              const paramImageField = item.fieldDescriptorList.find(f => f.name === 'diaopai_pic');
              if (paramImageField) {
                this.$set(paramImageField, 'defaultValue', res.data.productParamImageUrl);
              } else {
                // 如果没有该字段，添加一个
                item.fieldDescriptorList.push({
                  name: 'diaopai_pic',
                  defaultValue: res.data.productParamImageUrl,
                  type: 'INPUT',
                  rules: {},
                  options: null,
                  children: null
                });
              }
            } else {
              item.fieldDescriptorList = [{
                name: 'diaopai_pic',
                defaultValue: res.data.productParamImageUrl,
                type: 'INPUT',
                rules: {},
                options: null,
                children: null
              }];
            }
            // 触发响应式更新
            this.$set(this.oriDatas, index, item);
          });
          // 如果 schema 中还没有 diaopai_pic 字段，添加它并触发 Step3 重新渲染
          if (this.schema && !this.schema.diaopai_pic) {
            this.schema.diaopai_pic = {
              name: 'diaopai_pic',
              label: '产品参数图片',
              type: 'INPUT',
              rules: { requiredRule: 'true' },
              properties: [],
              valueTypeRule: 'url'
            };
          }
        }
      } catch (e) {
        console.error('fetchProductParamImage error', e);
      }
    },
  },
  mounted() {
    // this.init();
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 10px;
  background: #f8f8f8;
  font-weight: 600;
}
.conf {
  margin-top: 20px;
}
.tm-form-shop-tabs {
  & ::v-deep .el-tabs__content {
    display: none;
  }
}
::v-deep .tips {
  color: #a5a5a5;
}
.tips-danger {
  color: #e81313;
}
.platform-info-edit-wrp {
  // 使用自定义 loading
  ::v-deep .prod-custom-loading {
    background-color: rgba(255, 255, 255, 0.8) !important;
    .el-loading-spinner {
      top: 300px;
      .el-icon-loading {
        color: #999;
      }
    }
  }
  &.is-disabled {
    pointer-events: none;
    opacity: 0.6;
    * {
      pointer-events: none;
    }
  }
}
</style>
